<script>
    /*
    	SortComponent.svelte
    */

    import { onMount } from 'svelte';

    // TCARE components
    import SortButton from './SortButton.svelte';
    import SlidingSortFields from './SlidingSortFields.svelte';
    
    $: isFieldsOpen = false;

    export let onSort;              // on ResourceExplorerPage

    onMount(() => {
    })

</script>

<style>

    .sort-comp {
        width: 345px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 14px;
        /* border: 1px solid red; */
    }

    @media screen and (max-width: 600px) {
    }

    @media screen and (min-width: 601px) and (max-width: 1300px) {
    }

    @media screen and (min-width: 1201px) {
    }

</style>

<div class="sort-comp">
    <SlidingSortFields {isFieldsOpen} {onSort} />
    <SortButton onClick={() => isFieldsOpen = !isFieldsOpen} isSelected={isFieldsOpen}  />
</div>
